const registerReducer  = (state = { orders: [] } , action)=>{
    switch(action.type){
        case "registerCater": return {...state, orders: action.payload};
        default: return state;
    }
}


export default registerReducer